import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_CTA_LABEL, trackCheckout } from '../data/checkout';
const highlights = ['Premium Teaching Library', '5 Strategic Bonuses', 'Immediate Access'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-ivory" data-id="element-115" data-mp="4n1k6o86i6qx">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-sand/70 via-ivory to-ivory -z-10" data-id="element-116" data-mp="128fqzmni4jxa" />

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-117" data-mp="x8b6lljh351s">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-118" data-mp="s9qa9x7cd5im">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/50 bg-cream text-brand font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-119" data-mp="3d2bhzk51cpsw">
            🏌️ Golf Instructor Ready
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-brand" data-id="element-120" data-mp="3j6oe7qokeyt9">
            Solve a Full Year of Golf Lessons{' '}
            <span className="text-gold-gradient" data-id="element-121" data-mp="39cflb1vmh3uk">in Just 5 Minutes</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[300px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-122" data-mp="3ebioegs1kzzw">
          <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-123" data-mp="2ql6e4z9bqr65" />
          <img src="https://cdn.magicpatterns.com/uploads/tPEHxTxLxaLnFdMrT7MhYf/Diseno_sin_titulo_(53).png" alt="Golf Instructor Ready — 100 ready-to-teach golf lessons, 4 volumes and 5 bonus guides" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-124" data-mp="2vjzpom51w83o" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-125" data-mp="s3mfk97g6b1j">
          <p className="text-sm sm:text-lg md:text-xl leading-snug max-w-2xl mx-auto mb-2 sm:mb-3 font-semibold text-brand" data-id="element-126" data-mp="icrngo7ish86">
            Golf Instructor Ready — 100 Ready-to-Teach Golf Lessons
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-ink/70 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-127" data-mp="1b04cd515l14n">
            With drills, progressions and coaching solutions — everything structured and ready to use from today.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-128" data-mp="x1edpkyoqte6">
            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-129" data-mp="x0utfxlkbswz">
              🟡 {HERO_CTA_LABEL}
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-mist-text" data-id="element-130" data-mp="1x7hupaiwtwza">
            {highlights.map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-131" data-mp="268y69llgo553">
                <CheckCircle size={14} className="text-gold-dark" aria-hidden="true" data-id="element-132" data-mp="2b0fx3gtrspcc" />
                <span data-id="element-133" data-mp="2fzsugvi9pet6">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}